<template>
  <section class="zohoMea-section bg-dark-blue pattern-dark">
    <div class="map-pattern"></div>
    <div class="container" style="margin-bottom: -40px; margin-top: -70px">
      <div class="main-header mt-5">
        <h2 class="heading" data-aos="fade-up">
          {{ content.heading }}
          <span class="highlight">{{ content.headingHighlight }}</span
          ><br />{{ content.headingBreak }}
        </h2>
      </div>

      <div class="row justify-content-between">
        <div class="col-lg-6 mb-4">
          <div class="accordion" id="accordionExample">
            <!-- <div
              class="accordion-item"
              data-aos="fade-up"
              v-for="(item, index) in serviceContents"
              :data-aos-delay="`${(index + 1) * 100}`"
              :key="item"
              @click="goToSlide(index)"
            >
              <h2 class="accordion-header" :id="`heading${numberWords[index]}`">
                <button
                  :class="[
                    'accordion-button',
                    activeIndex === index ? '' : 'collapsed',
                  ]"
                  type="button"
                  data-bs-toggle="collapse"
                  :data-bs-target="`#collapse${numberWords[index]}`"
                  :aria-expanded="activeIndex === index ? 'true' : 'false'"
                  :aria-controls="`collapse${numberWords[index]}`"
                >
                  <i
                    :class="
                      $t(`serviceViewContent.service_contents[${index}].icon`)
                    "
                  ></i
                  >{{
                    $t(
                      `serviceViewContent['service_contents'][${index}]['title']`
                    )
                  }}
                </button>
              </h2>
              <div
                :id="`collapse${numberWords[index]}`"
                :class="[
                  'accordion-collapse',
                  'collapse',
                  activeIndex === index ? 'show' : '',
                ]"
                :aria-labelledby="`heading${numberWords[index]}`"
                data-bs-parent="#accordionExample"
              >
                <div class="accordion-body" style="cursor: pointer; height: 194px; overflow: hidden;">
                  <p>
                    {{
                      $t(
                        `serviceViewContent['service_contents'][${index}]['content']`
                      )
                    }}
                  </p>
                </div>
              </div>
            </div> -->
            <!-- One loop over content.steps, replacing three near-identical
                 hand-written blocks. Two of those carried :key="item" against
                 an `item` that does not exist in this scope. -->
            <div
              class="accordion-item"
              data-aos="fade-up"
              v-for="(step, index) in content.steps"
              :key="step.title"
              :data-aos-delay="`${(index + 1) * 100}`"
              @click="goToSlide(index)"
            >
              <h2 class="accordion-header" :id="`heading${numberWords[index]}`">
               <button
                :class="[
                  'accordion-button',
                  activeIndex === index ? '' : 'collapsed',
                ]"
                type="button"
                data-bs-toggle="collapse"
                :data-bs-target="`#collapse${numberWords[index]}`"
                :aria-expanded="activeIndex === index ? 'true' : 'false'"
                :aria-controls="`collapse${numberWords[index]}`"
                :style="accordionStyle(index)"
              >
                  <i :class="step.icon"></i
                  >{{ step.title }}
                </button>
              </h2>
              <div
                :id="`collapse${numberWords[index]}`"
                :class="[
                  'accordion-collapse',
                  'collapse',
                  activeIndex === index ? 'show' : '',
                ]"
                :aria-labelledby="`heading${numberWords[index]}`"
                data-bs-parent="#accordionExample"
              >
                <div class="accordion-body" style="cursor: pointer; height: 194px; overflow: hidden;">
                  <p>{{ step.content }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-5">
          <!-- <div class="owl-single no-dots owl-carousel">
            <div class="item" style="border-radius: 20px; overflow: hidden;">
              <img loading="lazy" :src="'https://measiteassetpublic.zohostratus.in/img/Service Image 2.png'"
                alt=""
                class="img-fluid"
              />
            </div>
            <div class="item" style="border-radius: 20px; overflow: hidden;">
              <img loading="lazy" :src="'https://measiteassetpublic.zohostratus.in/img/Service Image 3.png'"
                alt=""
                class="img-fluid"
              />
            </div>
            <div class="item" style="border-radius: 20px; overflow: hidden;">
              <img loading="lazy" :src="'https://measiteassetpublic.zohostratus.in/img/Service Image 1.png'"
                alt=""
                class="img-fluid"
              />
            </div>
          </div> -->
          <!-- <div class="owl-single no-dots owl-carousel" ref="owlCarousel" id="service-carousel" style="border-radius: 20px; overflow: hidden;">
            <div class="item" style="border-radius: 20px; overflow: hidden;">
              <img loading="lazy" :src="'https://measiteassetpublic.zohostratus.in/img/Service Image 2.png'" class="img-fluid" />
            </div>
            <div class="item" style="border-radius: 20px; overflow: hidden;">
              <img loading="lazy" :src="'https://measiteassetpublic.zohostratus.in/img/Service Image 3.png'" class="img-fluid" />
            </div>
            <div class="item" style="border-radius: 20px; overflow: hidden;">
              <img loading="lazy" :src="'https://measiteassetpublic.zohostratus.in/img/Service Image 1.png'" class="img-fluid" />
            </div>
          </div> -->

          <!-- <div style="width: 100%; height: 520px; border-radius: 15px; overflow: hidden; position: relative;"> -->
          <div>
            <!-- <transition name="smooth-fade" mode="out-in">
              <div
                class="item"
                style="border-radius: 20px; overflow: hidden;"
                :key="currentCarouselIndex"
              >
                <img loading="lazy" src="https://measiteassetpublic.zohostratus.in/img/Service Image 2.png" class="img-fluid" />
              </div>

            </transition> -->
            <!-- <transition name="smooth-fade" mode="out-in">
              <div :key="currentCarouselIndex">

                <div v-show="currentCarouselIndex === 0">
                  <img loading="lazy" src="https://measiteassetpublic.zohostratus.in/img/Service Image 2.png" class="img-fluid" />
                </div>

                <div v-show="currentCarouselIndex === 1">
                  <img loading="lazy" src="https://measiteassetpublic.zohostratus.in/img/Service Image 3.png" class="img-fluid" />
                </div>

                <div v-show="currentCarouselIndex === 2">
                  <img loading="lazy" src="https://measiteassetpublic.zohostratus.in/img/Service Image 1.png" class="img-fluid" />
                </div>

              </div>
            </transition> -->
            <transition name="smooth-fade" mode="out-in">
              <div :key="currentCarouselIndex">

                <div
                  v-for="(step, index) in content.steps"
                  :key="step.title"
                  v-show="currentCarouselIndex === index"
                  style="background-color: white; padding: 30px; width: 473px; border-radius: 10px; height: 500px; display: flex; justify-content: center; align-items: center;"
                >
                  <img
                    :width="step.image.width"
                    :height="step.image.height"
                    loading="lazy"
                    :src="step.image.src"
                    :alt="step.title"
                    class="img-fluid"
                    style="height: 100%; width: auto;"
                  />
                </div>

              </div>
            </transition>

          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script setup>
import { onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import $ from "jquery";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import "owl.carousel";

const activeIndex = ref(0);
const owlCarousel = ref(null);
const { t, locale, messages } = useI18n();
const numberWords = [
  "One",
  "Two",
  "Three",
  "Four",
  "Five",
  "Six",
  "Seven",
  "Eight",
  "Nine",
  "Ten",
];
function activate(index) {
  activeIndex.value = activeIndex.value === index ? activeIndex.value : index;

  //   if (owlCarousel.value) {
  //     console.log(owlCarousel.value);
  //     $(owlCarousel.value).trigger("to.owl.carousel", [index, 300]);
  //   }
}


onMounted(() => {
  // setTimeout(() => {
  //   $(owlCarousel.value).owlCarousel({
  //     items: 1,
  //     loop: false,
  //     margin: 10,
  //     nav: false,
  //     dots: false,
  //   });
  // }, 3000);

});

// onMounted(() => {
//   if (owlCarousel.value) {
//     $(owlCarousel.value).owlCarousel({
//       items: 1,
//       loop: false,
//       margin: 10,
//       nav: false,
//       dots: false,
//     });
//   }
// });

const serviceContents =
  messages.value[locale.value].serviceViewContent.service_contents;
</script>
<!-- <script setup>
import { onMounted, ref, nextTick } from "vue";
import { useI18n } from "vue-i18n";
import $ from "jquery";

import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import "owl.carousel/dist/owl.carousel.js";
window.$ = window.jQuery = $;


const activeIndex = ref(0);
const owlCarousel = ref(null);

const { t, locale, messages } = useI18n();

const numberWords = [
  "One", "Two", "Three", "Four", "Five",
  "Six", "Seven", "Eight", "Nine", "Ten"
];

const serviceContents =
  messages.value[locale.value].serviceViewContent.service_contents;

function goToSlide(index) {
  activeIndex.value = index;

  if (owlCarousel.value) {
    $(owlCarousel.value).trigger("to.owl.carousel", [index, 400]);
  }
}

onMounted(async () => {
  await nextTick(); // ⭐ FIX — ensures DOM & refs ready

  $(owlCarousel.value).owlCarousel({
    items: 1,
    loop: false,
    nav: false,
    dots: false,
  });
});
</script> -->


<script>
// const img1 = 'https://measiteassetpublic.zohostratus.in/img/Service Image 2.png';
// const img2 = 'https://measiteassetpublic.zohostratus.in/img/Service Image 3.png';
// const img3 = 'https://measiteassetpublic.zohostratus.in/img/Service Image 1.png';
const img1 = 'https://measiteassetpublic.zohostratus.in/img/Service Image 2.png';
const img2 = 'https://measiteassetpublic.zohostratus.in/img/Service Image 3.png';
const img3 = 'https://measiteassetpublic.zohostratus.in/img/Service Image 1.png';

import homeContent from '@/assets/home-content.json';

export default {
  name: "HomeServices",
  props: {
    content: {
      type: Object,
      default: () => homeContent.HomeServicesView
    }
  },
  // carouselImages: [
  //       'https://measiteassetpublic.zohostratus.in/img/Develop.png',
  //       'https://measiteassetpublic.zohostratus.in/img/Deliver.png',
  //       'https://measiteassetpublic.zohostratus.in/img/Discovery.png'
      // ]
  data() {
    return {
      currentCarouselIndex: 0,
      // carouselImages: [
      //   'https://measiteassetpublic.zohostratus.in/img/Service Image 2.png',
      //   'https://measiteassetpublic.zohostratus.in/img/Service Image 3.png',
      //   'https://measiteassetpublic.zohostratus.in/img/Service Image 1.png'
      // ],
      carouselImages: [],
      loadedImages: [],
      activeIndex: 0,
      borderColor: [
        "#E42527",
        "#089949",
        "#0B3FBF"
      ],
      colors: [
        "linear-gradient(90deg, rgba(228, 37, 39, 0.65) -14.85%, rgba(0, 0, 0, 0.00) 94.37%);",
        "linear-gradient(90deg, rgb(8 153 73 / 65%) -14.85%, rgba(0, 0, 0, 0.00) 94.37%)",
        "linear-gradient(90deg, rgba(11,63,151,0.65) -14.85%, rgba(0,0,0,0) 94.37%)"
      ]
    }
  },
  mounted() {
    this.preload();
    // this.$nextTick(() => {
    //         $("#service-carousel").owlCarousel({
    //             loop: true,
    //             margin: 20,
    //             nav: true,
    //             dots: true,
    //             responsive: {
    //             0: { items: 1 },
    //             600: { items: 2 },
    //             1000: { items: 3 },
    //             },
    //         });
    //     });
  },
  methods: {
    /**
     * Inline style for one accordion button.
     *
     * The first item deliberately gets nothing. Before this became a loop the
     * three blocks were written out by hand and only the second and third
     * carried a :style binding — the first never did, so it has never shown the
     * coloured active background. Returning null for it keeps the page looking
     * exactly as it does today; giving index 0 the same treatment as the others
     * is a design decision, not a refactor, so it is left alone here.
     */
    accordionStyle(index) {
      if (index === 0) return null;
      return this.currentCarouselIndex === index
        ? {
            background: `${this.colors[index]} !important`,
            borderLeft: `3.5px solid ${this.borderColor[index]} !important`
          }
        : {
            background: 'transparent !important',
            borderLeft: '1px solid white !important'
          };
    },
    goToSlide(index) {
      this.currentCarouselIndex = index;
    },
    preload() {
      this.carouselImages.forEach(src => {
        const img = new Image();
        img.src = src;
      });
    },
    getAccordionStyle(index) {
      if (index === 0 ) {
        return {
          background: `${this.colors[index]} !important`,
          borderLeft: `3.5px solid ${this.borderColor[index]} !important`
        };
      }
      if (index === 1 ) {
        return {
          background: `${colors[index]} !important`,
          borderLeft: `3.5px solid ${borderColor[index]} !important`
        };
      }
      if (index === 2 ) {
        return {
          background: `${colors[index]} !important`,
          borderLeft: `3.5px solid ${borderColor[index]} !important`
        };
      } else {
        return {
          background: "transparent !important",
          borderLeft: "1px solid white !important"
        };
      }


  }

  }
};
</script>
<style>

/* Position required for slide animation */
/* .item {
  position: absolute;
  width: 100%;
  height: 100%;
} */

/* Transition timing */
.slide-enter-active,
.slide-leave-active {
  transition: all 0.5s ease;
}

/* Start entering element off-screen (right) */
.slide-enter-from {
  transform: translateX(100%);
  opacity: 0;
}

/* End entering element centered */
.slide-enter-to {
  transform: translateX(0);
  opacity: 1;
}

/* Leaving element moves to the left */
.slide-leave-to {
  transform: translateX(-100%);
  opacity: 0;
}

/* Core properties for absolute animation */
/* .item {
  position: absolute;
  width: 100%;
  height: 100%;
} */

/* Smooth fade & scale transition */
.smooth-fade-enter-active,
.smooth-fade-leave-active {
  transition: all 0.55s cubic-bezier(0.16, 1, 0.3, 1);
}

/* Starting state for new element (fade + soft pop) */
.smooth-fade-enter-from {
  opacity: 0;
  transform: scale(0.97);
}

/* Ending state for new element */
.smooth-fade-enter-to {
  opacity: 1;
  transform: scale(1);
}

/* Leaving element fades + slightly shrinks */
.smooth-fade-leave-to {
  opacity: 0;
  transform: scale(0.98);
}


</style>